import { Navigate, Route, Routes } from "react-router-dom";
import FaceRecognition from "./components/FaceRecognition";
import HomePage from "./components/HomePage";

function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/start" element={<FaceRecognition />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
